import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import previewModal from './previewModal.vue';
import { plainOptions, getBase64, isImage, isVideo, isPDF, deleteValueOfObject } from './utils';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import { uploadFile } from '../../customer/applicationManage/request';
import { claimsDocumentAdd, claimsDocumentEdit } from './request';
import { cryptoDecrypt } from '@/utils/aes';
export default {
  components: {
    previewModal
  },
  data() {
    return {
      plainOptions,
      action: uploadFile,
      uploadAccept: '',
      addVisible: false,
      addForm: {
        name: '',
        description: '',
        templateDesc: '',
        format: [],
        fileList: [],
        sort: 0
      },
      continueState: false,
      isContinue: true,
      controlSelectList: [],
      indeterminate: false,
      checkAll: false,
      status: 'add',
      fileDialog: false,
      previewVisible: false,
      previewSrc: '',
      previewPDF: '',
      isPDFShow: false,
      isShow: '',
      currentPreviewIndex: 0,
      saveLoading: false
    };
  },
  computed: {
    ADD_RULES() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('文件名称'),
          trigger: 'blur'
        }, {
          message: '1-50' + this.$t('字符'),
          max: 50,
          min: 1
        }],
        sort: [{
          required: true,
          message: this.$t('请输入') + this.$t('排序数'),
          trigger: 'blur'
        }],
        // templateDesc: [
        //   {required: true, message: '请输入模板说明', trigger: 'blur'},
        //   {message: '1-500字符', max: 500, min: 1}
        // ],
        format: [{
          type: 'array',
          required: true,
          message: this.$t('请选择') + this.$t('文件格式'),
          trigger: 'change'
        }]
        // fileList: [{type: 'array', required: true, message: '请选择文件模板', trigger: 'change'}]
      };
    }
  },
  methods: {
    openModal(status, info, isContinue) {
      this.isContinue = isContinue;
      this.status = status;
      this.saveLoading = false;
      this.emptyForm();
      if (info) {
        this.$nextTick(() => {
          Object.assign(this.addForm, info);
          this.addForm.format = this.addForm.format.split(',');
          this.toChangeUploadAccept(this.addForm.format);
          this.addForm.fileList = this.addForm.fileList.map((i, index) => {
            i.status = 'done';
            i.uid = index + 1;
            return i;
          });
          this.checkAll = this.addForm.format.length === this.plainOptions.length ? true : false;
        });
      } else {
        if (this.addForm.name) {
          this.resetForm();
        }
      }
      this.addVisible = true;
    },
    clickPlus() {
      if (this.addForm.format.length == 0) {
        this.fileDialog = false;
        this.$refs.addFormRef.validateField('format');
      } else {
        this.fileDialog = true;
      }
    },
    removeUploadFile(file) {
      const index = this.addForm.fileList.indexOf(file);
      const newFileList = this.addForm.fileList.slice();
      newFileList.splice(index, 1);
      this.addForm.fileList = newFileList;
    },
    changeUpload({
      file,
      fileList
    }) {
      // console.log(fileList);
      const isThanMax = file.size / 1024 / 1024 < 50;
      const isVideoThanMax = file.size / 1024 / 1024 < 300;
      if (isVideo(file.name)) {
        if (!isVideoThanMax) {
          this.$message.error(this.$t('文件最大不超300M'));
          return;
        }
      } else {
        if (!isThanMax) {
          this.$message.error(this.$t('文件最大不超50M'));
          return;
        }
      }
      const fileType = file.name.substring(file.name.lastIndexOf('.')).substring(1);
      const res = this.addForm.format.indexOf(fileType);
      if (res > -1) {
        this.addForm.fileList = fileList.map(item => {
          if (item.response && item.response.code == 200 && item.status == 'done') {
            if (process.env.NODE_ENV === 'production') {
              // console.log(cryptoDecrypt(item.response.data));
              item.url = cryptoDecrypt(item.response.data).fileTempUrl;
            } else {
              item.url = item.response.data.fileTempUrl;
            }
          }
          return item;
        });
      } else {
        this.$message.error(this.$t('文件格式错误'));
      }
      setTimeout(() => {
        const classActions = document.getElementsByClassName('ant-upload-list-item-actions');
        if (classActions.length > 0) {
          for (const key in classActions) {
            if (classActions[key].firstChild) {
              classActions[key].firstChild.style.opacity = '1';
              classActions[key].firstChild.style.pointerEvents = 'initial';
            }
          }
        }
      }, 50);
    },
    // 预览处理
    async handlePreview(file) {
      this.isShow = '';
      if (isImage(file.name)) {
        this.isShow = 'image';
      }
      if (isVideo(file.name)) {
        this.isShow = 'video';
      }
      this.isPDFShow = isPDF(file.name);
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      if (this.isShow === 'image' || this.isShow === 'video') {
        this.previewSrc = file.url || file.preview;
        this.currentPreviewIndex = this.addForm.fileList.indexOf(file);
      } else if (this.isPDFShow) {
        this.previewPDF = file.url || file.response.data.fileTempUrl;
        window.open(this.previewPDF);
        return;
      } else {
        window.open(file.url || file.response.data.fileTempUrl);
        return;
      }
      this.previewVisible = true;
    },
    // 设置上传文件限制格式
    toChangeUploadAccept(data) {
      if (data.length) {
        data = data.map(i => '.' + i);
        this.uploadAccept = data.join(',');
      } else {
        this.uploadAccept = 'image/*';
      }
    },
    // 文件格式状态改变
    onCheckAllChange(e) {
      Object.assign(this.addForm, {
        format: e.target.checked ? this.plainOptions : []
      });
      this.indeterminate = false;
      this.checkAll = e.target.checked;
      this.toChangeUploadAccept(this.addForm.format);
    },
    onChangeFormat(checkedList) {
      this.indeterminate = !!checkedList.length && checkedList.length < this.plainOptions.length;
      this.checkAll = checkedList.length === this.plainOptions.length;
      this.$refs.addFormRef.validateField('format');
      this.toChangeUploadAccept(this.addForm.format);
    },
    // 是否继续添加
    onContinueToAdd(e) {
      this.continueState = e.target.checked;
    },
    saveAdd() {
      this.$refs.addFormRef.validate(async valid => {
        if (valid) {
          this.saveLoading = true;
          let templateUrl = [];
          let returnRes = true;
          this.addForm.fileList.map(i => {
            if (i.status === 'done') {
              templateUrl.push(i.url ? i.url : i.response.data.fileTempUrl);
            } else {
              this.$message.warn(this.$t('文件上传中或文件上传错误'));
              returnRes = false;
              return;
            }
          });
          if (!returnRes) {
            this.saveLoading = false;
            return;
          }
          const saveURL = this.status === 'add' ? claimsDocumentAdd : claimsDocumentEdit;
          let obj = recursionCopy(this.addForm);
          obj = deleteValueOfObject(obj, 'fileList');
          try {
            const res = await saveURL(Object.assign(obj, {
              format: obj.format.join(','),
              templateUrl: JSON.stringify(templateUrl),
              isContinue: this.isContinue
            }));
            this.saveLoading = false;
            this.$message.success(this.$t('保存成功') + '!');
            this.$emit('save', res);
            if (this.continueState) {
              this.indeterminate = false;
              this.emptyForm();
              this.resetForm();
            } else {
              this.addVisible = false;
            }
          } catch (error) {
            this.saveLoading = false;
          }
        }
      });
    },
    closeAddVisible() {
      this.addVisible = false;
      this.continueState = false;
      this.indeterminate = false;
      this.emptyForm();
      this.resetForm();
    },
    resetForm() {
      this.$refs.addFormRef.resetFields();
    },
    emptyForm() {
      this.addForm.claimsDocumentId = null;
      this.addForm.name = '';
      this.addForm.description = '';
      this.addForm.templateDesc = '';
      this.addForm.format = [];
      this.addForm.fileList = [];
      this.addForm.sort = '';
    }
  }
};